import { render } from "./ViewModule.vue?vue&type=template&id=97ba7088"
import script from "./ViewModule.vue?vue&type=script&lang=js"
export * from "./ViewModule.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__